import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "vcode",
  id: "vertifycode"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "labels" }
const _hoisted_4 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    current: 2,
    isDisabled: _ctx.isDisabled,
    prePathName: _ctx.isPiVerify ? 'statement' : 'pi'
  }, {
    default: _withCtx(() => [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "身份验证", -1)),
      _createElementVNode("div", null, " 为保障您的账户安全，我们已发送验证码至您的预留手机号码 +" + _toDisplayString(_ctx.areaCode) + " -" + _toDisplayString(_ctx.phoneConvertFunc) + "： ", 1),
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "tel",
          maxlength: "6",
          ref: "codeRef",
          class: "code",
          id: "code",
          name: "captcha",
          onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.focus = true)),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.code) = $event)),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focus = false)),
          disabled: _ctx.disabled,
          required: "",
          "aria-errormessage": "验证码不能为空"
        }, null, 40, _hoisted_2), [
          [_vModelText, _ctx.code]
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.length, (item, index) => {
            return (_openBlock(), _createElementBlock("label", {
              class: _normalizeClass(["label", { active: _ctx.focus === true && index === _ctx.currentIndex }]),
              for: "code",
              key: index,
              textContent: _toDisplayString(_ctx.arrCode[index])
            }, null, 10, _hoisted_4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", {
        class: "btn-resend",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendCode && _ctx.sendCode(...args)))
      }, _toDisplayString(_ctx.codeDisabled ? `${_ctx.seconds}秒后重新发送` : '重新发送验证码'), 1)
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled", "prePathName"]))
}